let connect = require("react-redux").connect;
import React from "react";

let actions = require("../actions/actions");
let CreatorInfo = require("./moderation-batch-creator-info");
let Loading = require("./loading");
let ModerationPreviewMenu = require("./moderation-preview-menu");
let ModerationIconCards = require("./moderation-icon-cards");

class ModerationUnderReview extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        this.props.previewUploadIcons(this.props.uploadId, "");
    }

    render() {
        if (this.props.upload) {
            return (
                <div>
                    <ModerationPreviewMenu
                        upload={this.props.upload}
                        icons={this.props.icons}
                    />
                    <ModerationIconCards
                        upload={this.props.upload}
                        icons={this.props.icons}
                        preview={true}
                    />
                </div>
            );
        } else {
            return <Loading />;
        }
    }
}

function mapStateToProps(state, ownProps) {
    let icons = [],
        iconsSelected = 0,
        upload = undefined,
        totalIconsLeft = icons.length;

    if (state.uploads.keys) {
        state.uploads.keys.forEach(uploadId => {
            if (state.uploads[uploadId].status === "preview") {
                upload = state.uploads[uploadId];

                upload.pagination = {
                    icons: state.pagination.previewIcons[""]
                };

                if (upload.icons) {
                    upload.iconKeys.forEach(iconId => {
                        let i = JSON.parse(
                            JSON.stringify(upload.icons[iconId])
                        );
                        if (!i.status) {
                            totalIconsLeft = totalIconsLeft - 1;
                            icons.push(i);
                        }
                    });
                }
            }
        });
    }

    return { icons, upload, iconsSelected, totalIconsLeft };
}

module.exports = connect(mapStateToProps, {
    previewUploadIcons: actions.previewUploadIcons,
    showModal: actions.showModal
})(ModerationUnderReview);
